export const POSTHOG_DISTINCT_ID_HEADER = 'X-POSTHOG-DISTINCT-ID';
export const POSTHOG_SESSION_ID_HEADER = 'X-POSTHOG-SESSION-ID';

export const OPPORTUNITY_GROUP_TYPE = 'opportunity';

export function getServiceName(): string {
  return process.env.NEXT_PUBLIC_SERVICE_NAME ?? 'red-experience';
}
